export default [
	"AWESOME!",
	"PERFECT!",
	"GREAT!",
	"IMPRESSIVE!",
	"SUPER!",
	"COOL!",
	"JOB!",
	"NICE!",
	"DONE!",
	"DELICIOUS!",
	"DIVINE!",
	"TASTY!"
]